import { FLEX, FONT } from "@/styles/common";
import { Box, Flex } from "@chakra-ui/react";
import styled from "@emotion/styled";

interface WrapperProps {
    isFullImg: boolean;
}

export const Wrapper = styled(Box)<WrapperProps>`
    & > div {
        visibility: ${({ isFullImg }) => !isFullImg && "hidden"};
    }

    & > section {
        max-width: ${({ isFullImg }) => !isFullImg && "100% !important"};
        top: ${({ isFullImg }) => !isFullImg && "auto"};
        margin-bottom: ${({ isFullImg }) => !isFullImg && "0"};
    }
`;

export const CustomBox = styled(Box)`
    position: absolute;
    width: 100%;
    bottom: 248px;
`;

export const CustomFlex = styled(Flex)`
    position: relative;
    top: 142px;
    margin-bottom: 142px;
    background: ${({ theme }) => theme.COLOR.pagination[100]};

    & > div {
        ${FLEX.column("center", "center", 40)}
        text-align: center;

        & div {
            padding: 0;
        }

        & > div:first-of-type::before {
            width: auto;
        }

        & > div:first-of-type p:first-of-type {
            ${FONT("cormorant", 32, 500)}
            color:${({ theme }) => theme.COLOR.bgColor[300]};

            @media (max-width: ${({ theme }) => theme.MEDIA.mobile}) {
                ${FONT("cormorant", 16, 500)}
            }
        }
        & > div:first-of-type p:last-of-type {
            ${FONT("notoSerif", 40, 300)}

            @media (max-width: ${({ theme }) => theme.MEDIA.mobile}) {
                ${FONT("notoSerif", 24, 500)}
            }
        }
    }
`;
